export const API = {

    GET_CDO: "/Dispatch/getCDO",
    GET_CDO_DETAILS: "/Dispatch/getCDOWithItems",
    GET_TRIP_CATEGORY: "/Dispatch/get_trip_category",
    CREATE_VDN: "/Dispatch/createVdn",
    UPDATE_VDN: "/Dispatch/updateVdn",
    GET_VDN: "/Dispatch/getVDN",
    GET_VDN_DETAILS: "/Dispatch/getVDNWithItems",
}